import { NavLinkConfig, NavLinkId } from '../data/types/nav';
import { NavConfig } from '../data/constants/nav';

const migratedLinks = (...linkIds: NavLinkId[]) =>
  linkIds.reduce(
    (acc, id) => ({ ...acc, [id]: NavConfig.linkConfigs[id] }),
    {} as Partial<Record<NavLinkId, NavLinkConfig>>
  );

// DEV/LOCAL use dev links
export const devMigratedLinks = migratedLinks(
  'MN_ADDENDUM_C',
  'TX_INJURED_INACTIVE_REHAB',
  'TX_TAXI_SQUAD',
  'TX_PLAYER_TRACKING',
  'RSTR_MJ_SUMMARY',
  'RSTR_MN_SUMMARY',
  'RSTR_MJ_MN_ROSTERS',
  'SYS_BATCHES',
  'SYS_BATCH_UTILITY',
  'SYS_SYSTEM_DATES',
  'ADVANCED_SEARCH',
  'CLIPBOARD',
  'RSTR_TWO_WAY_PLAYERS',
  'MJ_AWARD_BONUS_PACKAGES',
  'AWARD_BONUS_PACKAGE',
  'MN_VERIFICATION',
  'MN_DRAFT_CONTRACTS',
  'SYS_MNFA_PROCESS',
  'SYS_END_OF_SEASON_SERVICE_PROCESS',
  'INT_WLP_CLUB_COMMS',
  'PROFILE_PRO_HISTORY',
  'PROFILE_PRO_SUMMARY',
  'EMP_ROSTERS',
  'EMP_DOCTORS',
  'EMP_TRANSLATORS',
  'INT_DRUG_TEST_REQUESTS',
  'INT_L2_REG',
  'INT_L1_REG',
  'RSTR_PARTNER_LEAGUE',
  'R4_DRAFT_LIVE',
  'R4_DRAFT_DAY_BOC',
  'R4_DRAFT_DAY_CLUB',
  'R4_DRAFT_DISPLAY',
  'R4_POST_DRAFT',
  'R4_CONNECTIVITY',
  'R4_COMM_SCREEN_DISPLAY',
  'R4_DRAFT_TEST_PICKER',
  'PROFILE_EMP_HISTORY',
  'PROFILE_EMP_CONTRACTS',
  'CSP_SCHOOL',
  'CEP_SCHOOLS',
  'UTIL_AFFILIATES',
  'AFFILIATE_PROFILE',
  'R5_DRAFT_LIVE',
  'R5_DRAFT_ADMIN',
  'R5_DRAFT_HISTORY',
  'R5_DRAFT_ORDER',
  'R5_RESERVE_LISTS',
  'R5_SELECTABLE_PLAYERS',
  'PROFILE_PRO_CONTRACTS',
  'PROFILE_PRO_CONTRACTS_AND_INV',
  'RSTR_DETAILS',
  'REPORTS',
  'UTIL_SOCIAL_MEDIA'
);

// STG/TRN/BF/PROD use prod links
export const prodMigratedLinks = migratedLinks(
  'MN_DRAFT_CONTRACTS',
  'MN_ADDENDUM_C',
  'TX_INJURED_INACTIVE_REHAB',
  'RSTR_MJ_SUMMARY',
  'RSTR_MN_SUMMARY',
  'RSTR_MJ_MN_ROSTERS',
  'RSTR_TWO_WAY_PLAYERS',
  'TX_PLAYER_TRACKING',
  'SYS_BATCHES',
  'SYS_BATCH_UTILITY',
  'SYS_SYSTEM_DATES',
  'SYS_MNFA_PROCESS',
  'SYS_END_OF_SEASON_SERVICE_PROCESS',
  'ADVANCED_SEARCH',
  'MN_VERIFICATION',
  'EMP_ROSTERS',
  'PROFILE_PRO_HISTORY',
  'PROFILE_EMP_HISTORY',
  'PROFILE_PRO_SUMMARY',
  'CSP_SCHOOL',
  'CEP_SCHOOLS',
  'CLIPBOARD',
  'INT_DRUG_TEST_REQUESTS',
  'UTIL_AFFILIATES',
  'AFFILIATE_PROFILE',
  'INT_WLP_CLUB_COMMS',
  'R4_DRAFT_LIVE',
  'R4_PRE_DRAFT',
  'R4_DRAFT_ORDER',
  'R4_DRAFT_DAY_BOC',
  'R4_DRAFT_DAY_CLUB',
  'R4_DRAFT_DISPLAY',
  'R4_POST_DRAFT',
  'R4_CONNECTIVITY',
  'R4_COMM_SCREEN_EDITOR',
  'R4_COMM_SCREEN_DISPLAY',
  'R4_DRAFT_TEST_PICKER',
  'PROFILE_PRO_CONTRACTS',
  'PROFILE_PRO_CONTRACTS_AND_INV',
  'INT_L2_REG',
  'INT_L1_REG',
  'RSTR_PARTNER_LEAGUE',
  'TX_TAXI_SQUAD',
  'R5_DRAFT_LIVE',
  'R5_DRAFT_ADMIN',
  'R5_DRAFT_HISTORY',
  'R5_RESERVE_LISTS',
  'R5_SELECTABLE_PLAYERS',
  'PROFILE_EMP_CONTRACTS',
  'TX_PLAYER_TRACKING',
  'REPORTS',
  'UTIL_SOCIAL_MEDIA'
);
